module.exports = __webpack_public_path__ + "static/media/CompleteEvaluate.8a346bc4.svg";